var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "xhname" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入型号" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.xhname,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "xhname", $$v)
                          },
                          expression: "searchForm.xhname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "source" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入品牌" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.source,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "source", $$v)
                          },
                          expression: "searchForm.source",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "gongyingshang" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入供应商" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.gongyingshang,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "gongyingshang", $$v)
                          },
                          expression: "searchForm.gongyingshang",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入商品名称" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "title", $$v)
                          },
                          expression: "searchForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "筛选数量" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请输入筛选数量",
                            clearable: "",
                          },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.stock_filter,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "stock_filter", $$v)
                            },
                            expression: "searchForm.stock_filter",
                          },
                        },
                        _vm._l(_vm.filterNum, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSearchBtn()
                        },
                      },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "div",
            { staticClass: "inventory-alert" },
            [
              _c("el-alert", {
                attrs: {
                  title: "总已税金额：" + _vm.taxedAmount,
                  type: "success",
                },
              }),
              _c("el-alert", {
                staticClass: "alert-error",
                attrs: {
                  title: "总未税金额：" + _vm.untaxedAmount,
                  type: "error",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus custom-btn",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增库存")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: {
                loading: _vm.exportLoading,
                type: "success",
                icon: "el-icon-download",
                size: "small",
              },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出Excel ")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: {
                loading: _vm.importLoading,
                type: "warning",
                icon: "el-icon-plus",
                size: "small",
              },
              on: { click: _vm.handleImport },
            },
            [_vm._v("导入Excel ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "el-icon-delete",
              staticStyle: { "margin-left": "10px" },
              attrs: { size: "small", type: "danger" },
              on: {
                click: function ($event) {
                  return _vm.handleDelete({ type: "batch" }, null, null)
                },
              },
            },
            [_vm._v("批量删除 ")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品编码", prop: "id", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "title" },
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", {
                attrs: { label: "库存数量", prop: "number" },
              }),
              _c("el-table-column", {
                attrs: { label: "未税价格", prop: "wshui" },
              }),
              _c("el-table-column", {
                attrs: { label: "含税价格", prop: "hshui" },
              }),
              _c("el-table-column", {
                attrs: { label: "零售价", prop: "retail_price", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "自定义价格", prop: "zdyprice", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "收票状态", prop: "spzt" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.spzt == 0
                                ? "未税"
                                : scope.row.spzt == 1
                                ? "已到"
                                : "未到"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "产地", prop: "address" },
              }),
              _c("el-table-column", {
                attrs: { label: "包装", prop: "baozhuang" },
              }),
              _c("el-table-column", {
                attrs: { label: "库房货位", prop: "kufang" },
              }),
              _c("el-table-column", {
                attrs: { label: "进货日期", prop: "settime", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "供应商", prop: "gongyingshang", width: "140" },
              }),
              _c("el-table-column", {
                attrs: { label: "合同状态", prop: "zt" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.zt == 1 ? "开放" : "锁定") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "250", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "small",
                              disabled:
                                scope.row.state === "T" ||
                                _vm.disabledIndexes.includes(scope.row.id),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addToDrawer(
                                  scope.row,
                                  1,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [_vm._v("添加 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope)
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              iconColor: "red",
                              title: "确认删除此条数据吗？",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleDelete(
                                  { type: "single" },
                                  scope,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "el-icon-delete",
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  type: "danger",
                                },
                                slot: "reference",
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: {
          dialog: _vm.dialog,
          "form-data": _vm.editFormData,
          type: _vm.type,
          submitLoading: _vm.submitLoading,
        },
        on: { submit: _vm.handleSubmit, close: _vm.handleClose },
      }),
      _c("Import", {
        attrs: { dialog: _vm.dialogImport },
        on: { close: _vm.handleImportClose, uploadSuccess: _vm.handleUpload },
      }),
      _c(
        "el-button",
        {
          staticClass: "add-btn",
          attrs: { type: "primary", plain: "" },
          on: { click: _vm.handleAddXname },
        },
        [
          _vm._v(
            "已添加（" +
              _vm._s(_vm.addedData.length || _vm.addedNum || 0) +
              "） "
          ),
        ]
      ),
      _c("AddCart", {
        attrs: { data: _vm.addedData, dialog: _vm.drawerVisible },
        on: {
          handleCloseAddCart: _vm.handleCloseAddCart,
          removeFromDrawer: _vm.removeFromDrawer,
          handleClear: _vm.handleClear,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }